import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { confirmarCita } from "../services/citas.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaConfirmar = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const confirmarCitaMutation = useMutation({
        mutationFn: confirmarCita,
        onSuccess: (cita, variables, context) => {
            if(variables.paciente !== '0'){
                queryClient.invalidateQueries({ queryKey: ['citas', variables.paciente], exact: false });
            }
            queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
            queryClient.invalidateQueries({ queryKey: ['agendaInmunoterapia'], exact: false });
            variables.success();
            dispatch(successNotification('Cita confirmada'));
        },
        onError: (error, variables, context) => {
            variables.error();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        confirmarCitaMutation,
    }
}